import $api from "../../axios"
import { AppDispatch } from "../index"
import { authSlice } from "../slices/authSlice"
import { IAuthResponse } from "../../models/auth"

interface AuthData {
  email: string
  password: string
}

export const login = (data: AuthData) => async (dispatch: AppDispatch) => {
  try {
    dispatch(authSlice.actions.loginProcess())
    const response = await $api.post<IAuthResponse>('user/login', data)
    dispatch(authSlice.actions.login(response.data))
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(authSlice.actions.fieldError(e.response.data))
    }
  }
}

export const logout = () => async (dispatch: AppDispatch) => {
  await $api.post("user/logout")
  dispatch(authSlice.actions.logout())
}

export const userUpdate = (data: object) => async (dispatch: AppDispatch) => {
  try {
    const response = await $api.put<IAuthResponse>("user/edit-user-data", data)
    dispatch(authSlice.actions.userUpdate(response.data))
    return true
  } catch (e: any) {
    console.log(e)
  }
}

export const changePassword = (data: object) => async (dispatch: AppDispatch) => {
  try {
    await $api.put("user/change-password", data)
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(authSlice.actions.fieldError(e.response.data))
    }
  }
}

export const sendRecoveryEmail = (email: string) => async (dispatch: AppDispatch) => {
  try {
    await $api.post("user/send-recovery-email", {email})
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(authSlice.actions.fieldError(e.response.data))
    }
  }
}

export const resetUserPassword = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(authSlice.actions.loginProcess())
    const response = await $api.post("user/reset-password", data)
    dispatch(authSlice.actions.login(response.data))
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(authSlice.actions.fieldError(e.response.data))
    }
  }
}
